module.exports = __webpack_public_path__ + "assets/img/benefit-month-card-3ec5d6f4.png";